import React from 'react';
import { MobilePopupBottom } from '@lt/components';
import {
  TgLimitLogo,
  VkLimitLogo,
  MaxLimitLogo,
} from '@lt/components/icons-react/communication';
import { i18n } from '@lt/localization';
import { NBSP } from 'src/constants/common';
import Popup from '../Popup';
import type { PopupComponentProps } from './types';
import styles from './TouristLimitModal.module.css';

const popupClassNames = {
  modal: styles.modalPopup,
  overlay: styles.bannerPopup,
};

const closeButtonStyles = {
  width: '20px',
  height: '16px',
  right: '9px',
  top: '7px',
  cursor: 'pointer',
};

const mobileBottomshitOptions = {
  showHandlebar: true,
};

export const TouristLimitModal = (props: PopupComponentProps) => {
  const { isMobile, isOpen, onClose } = props;
  return (
    <>
      {isMobile ? (
        <MobilePopupBottom
          onClick={onClose}
          visible={isOpen}
          options={mobileBottomshitOptions}
          className={styles.mobileContainer}
        >
          <div>
            <div className={styles.titleMobile}>
              {i18n.t('cigarettePreview.touristsLimitTitle', { nbsp: NBSP })}
            </div>
            <div className={styles.descriptionMobile}>
              {i18n.t('cigarettePreview.touristsLimitDescription')}
            </div>
            <ul className={styles.buttonsConatinerMobile}>
              <li className={styles.buttonMobile}>
                <a
                  className={styles.buttonMobileLink}
                  href={i18n.t('headerMenu.feedback.max.link')}
                >
                  <div className={styles.iconWrapper}>
                    <MaxLimitLogo />
                  </div>
                  <span className={styles.buttonMobileLinkText}>
                    {i18n.t('headerMenu.feedback.max.title')}
                  </span>
                </a>
              </li>
              <li className={styles.buttonMobile}>
                <a
                  className={styles.buttonMobileLink}
                  href={i18n.t('headerMenu.feedback.telegram.link')}
                >
                  <div className={styles.iconWrapper}>
                    <TgLimitLogo />
                  </div>
                  <span className={styles.buttonMobileLinkText}>
                    {i18n.t('headerMenu.feedback.telegram.title')}
                  </span>
                </a>
              </li>
              <li className={styles.buttonMobile}>
                <a
                  className={styles.buttonMobileLink}
                  href={i18n.t('headerMenu.feedback.vk.link')}
                >
                  <div className={styles.iconWrapper}>
                    <VkLimitLogo />
                  </div>
                  <span className={styles.buttonMobileLinkText}>
                    {i18n.t('headerMenu.feedback.vk.title')}
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </MobilePopupBottom>
      ) : (
        <Popup
          open={isOpen}
          onClose={onClose}
          classNames={popupClassNames}
          closeButtonStyles={closeButtonStyles}
        >
          <div>
            <div className={styles.titleDesktop}>
              {i18n.t('cigarettePreview.touristsLimitTitle', { nbsp: NBSP })}
            </div>
            <div className={styles.descriptionDesktop}>
              {i18n.t('cigarettePreview.touristsLimitDescription')}
            </div>
            <ul className={styles.buttonsConatiner}>
              <li className={styles.button}>
                <a
                  className={styles.buttonLink}
                  href={i18n.t('headerMenu.feedback.max.link')}
                >
                  <div className={styles.iconWrapper}>
                    <MaxLimitLogo />
                  </div>
                  <span className={styles.buttonLinkText}>
                    {i18n.t('headerMenu.feedback.max.title')}
                  </span>
                </a>
              </li>
              <li className={styles.button}>
                <a
                  className={styles.buttonLink}
                  href={i18n.t('headerMenu.feedback.telegram.link')}
                >
                  <div className={styles.iconWrapper}>
                    <TgLimitLogo />
                  </div>
                  <span className={styles.buttonLinkText}>
                    {i18n.t('headerMenu.feedback.telegram.title')}
                  </span>
                </a>
              </li>
              <li className={styles.button}>
                <a
                  className={styles.buttonLink}
                  href={i18n.t('headerMenu.feedback.vk.link')}
                >
                  <div className={styles.iconWrapper}>
                    <VkLimitLogo />
                  </div>
                  <span className={styles.buttonLinkText}>
                    {i18n.t('headerMenu.feedback.vk.title')}
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </Popup>
      )}
    </>
  );
};
